// This file is generated. Edit build/generate-shaders.ts, then run `npm run codegen`.
export default 'flat in vec4 v_output_error_encoded;void main() {fragColor=v_output_error_encoded;}';
